import React from 'react';
import { motion } from 'framer-motion';

interface ServicesCTASectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  descriptionAr?: string;
  descriptionEn?: string;
  buttonTextAr?: string;
  buttonTextEn?: string;
}

const ServicesCTASection: React.FC<ServicesCTASectionProps> = ({
  language = 'ar',
  titleAr = "هل تحتاج إلى استشارة مجانية؟",
  titleEn = "Need a Free Consultation?",
  descriptionAr = "فريقنا من الخبراء جاهز لمساعدتك في تخطيط وتنفيذ مشروعك بأفضل الطرق وأقل التكاليف",
  descriptionEn = "Our team of experts is ready to help you plan and execute your project in the best ways and at the lowest costs",
  buttonTextAr = "احصل على استشارة مجانية",
  buttonTextEn = "Get a Free Consultation"
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="bg-gradient-to-r from-primary-600 to-primary-700 py-20">
      <div className="container-custom text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {isRTL ? titleAr : titleEn}
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            {isRTL ? descriptionAr : descriptionEn}
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="btn-secondary text-lg px-8 py-4"
          >
            {isRTL ? buttonTextAr : buttonTextEn}
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesCTASection; 